import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Button, IconButton, Tooltip } from 'Permafrost/index';
import { StyledKabobMenu } from './KabobMenu.styles';
export const KabobMenu = ({ id, className, disabled, leftAligned = false, menuOptions }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const iconButtonRef = useRef(null);
    // Close the menu when clicking outside of the menu or outside of the kabob icon button
    useEffect(() => {
        const listener = (e) => {
            if (!menuRef.current ||
                !iconButtonRef.current ||
                menuRef.current.contains(e.target) ||
                iconButtonRef.current.contains(e.target)) {
                return;
            }
            setIsOpen(false);
        };
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('click', listener);
        };
    }, [menuRef, iconButtonRef]);
    return (React.createElement(StyledKabobMenu, { id: id, className: classNames(className, { 'left-aligned': leftAligned }) },
        React.createElement(IconButton, { className: classNames('KabobMenu--kabob-btn', { 'no-background': !isOpen }), isDisabled: disabled, iconName: "kabob", label: "", onPress: () => setIsOpen(!isOpen), "data-testid": "icon-button--kabob-menu", ref: iconButtonRef }),
        isOpen ? (React.createElement("div", { className: "KabobMenu--menu", ref: menuRef }, menuOptions.map((option) => {
            return (React.createElement("div", { className: classNames('menu-item', { disabled: option.disabled }), "data-tip": true, "data-for": option.id, key: option.id, "data-testid": `kabob-menu-item--${option.id}` },
                option.iconName ? (React.createElement(IconButton, { className: "menu-item-btn", isDisabled: option.disabled, iconName: option.iconName, label: option.label, onPress: () => {
                        option.onClick();
                        setIsOpen(false);
                    } })) : (React.createElement(Button, { className: "menu-item-btn", disabled: option.disabled, onClick: () => {
                        option.onClick();
                        setIsOpen(false);
                    } }, option.label)),
                option.disabledText && option.disabled ? (React.createElement(Tooltip, { for: option.id, questionMark: false }, option.disabledText)) : null));
        }))) : null));
};
//# sourceMappingURL=KabobMenu.js.map